const image =
{
    img_1: require('./components/assets/img_1.webp'),
    img_2: require('./components/assets/img_2.webp'),
    img_3: require('./components/assets/img_3.webp'),
    img_4: require('./components/assets/img_4.webp'),
    img_5: require('./components/assets/img_5.webp'),
    img_6: require('./components/assets/img_6.webp'),
    img_7: require('./components/assets/img_7.webp'),
    img_8: require('./components/assets/img_8.webp'),
    img_9: require('./components/assets/img_9.webp'),
    img_10: require('./components/assets/img_10.webp'),
    img_11: require('./components/assets/img_11.webp'),
    img_12: require('./components/assets/img_12.webp'),
    img_13: require('./components/assets/img_13.webp'),
    img_14: require('./components/assets/img_14.webp'),
    img_15: require('./components/assets/img_15.webp'),
    img_16: require('./components/assets/img_16.webp'),
    img_17: require('./components/assets/img_17.webp'),
    img_18: require('./components/assets/img_18.webp'),
    img_19: require('./components/assets/img_19.webp'),
    img_20: require('./components/assets/img_20.webp'),
    img_21: require('./components/assets/img_21.webp'),

    who_we_are_1: require('./assets/About-ExperimindLabs-1st-pic.webp'),
    who_we_are_2: require('./assets/About-ExperimindLabs-2nd-pic.webp'),

    arrow: require('./assets/arrow-right-circle.webp'),

    shiksha: require('./assets/Experimind-labs-Robot-Shiksha.webp'),
    psl: require('./assets/Experimind_PSL.webp'),
    prastuti: require('./assets/Experimind-Prastuti.webp'),
    geomagic: require('./assets/Experimind_GeoMagic.webp'),
    anubhav: require('./assets/Experimind-Anubhav-Kit.webp'),

    aicnitte: require('./assets/AIC_nitte_Logo.webp'),
    aim: require('./assets/AIM_Logo.webp'),
    ngi: require('./assets/NGI_Logo.webp'),
    rv: require('./assets/RVU_Logo.webp'),
    nitte: require('./assets/Nitte_Logo.webp'),
    ssrvm: require('./assets/Ravishankar_Logo.webp'),
    sbc: require('./assets/SBC_Logo.webp'),
    yfs: require('./assets/YFS_Logo.webp'),
    snm: require('./assets/SNM.webp'),

    whychooseus: require('./assets/Experimindlabs-kids-studing.webp'),

    meeting: require('./assets/Experimindlabs-meeting.webp'),
    meeting2: require('./assets/Experimind-labs-Meeting-Room.webp'),

    vision_icons: require('./assets/eye.webp'),
    mission_icons: require('./assets/mountain.webp'),
    values_icons: require('./assets/handshake.webp'),
    
    insta: require('./assets/instagram.webp'),
    Twitter: require('./assets/twitter-x.webp'),
    linkedin: require('./assets/linkedin.webp'),
    youtube: require('./assets/youtube.webp'),

    ceo: require('./assets/Akshay-Mashelkar.webp'),
    director: require("./assets/Latha-Bhandari.webp"),
    cto: require('./assets/Adarsh-Devadiga.webp'),
    techinical_engineer: require('./assets/Anand-J.webp'),
    accountant: require('./assets/Shruthi.webp'),
    production: require('./assets/Sagar-Shanbhogue.webp'),
    intern3: require('./assets/Sharath-Dinesh.webp'),
    
    contenthead: require('./assets/Subramanya-Hegde.webp'),
    mentor: require('./assets/Ganapathi-Hegde.webp'),
    advisor: require('./assets/Sandesh-Shetty.webp'),
    
    intern1: require('./assets/Sapekcha-Bhandari.webp'),
    intern2: require('./assets/Kavan-Shetty.webp'),
    intern4: require('./assets/Harish-Vishwanath-Bhat.webp'),
    intern5: require('./assets/Sandesh-Shripad-hegde.webp'),
    intern6: require('./assets/Shramanth-P-Acharya.webp'),
    intern7: require('./assets/Manish-Poojary.webp'),
    
    gallery1: require('./assets/Experimind_Gallery_1.webp'),
    gallery2: require('./assets/Experimind_Gallery_2.webp'),
    gallery3: require('./assets/Experimind_Gallery_3.webp'),
    gallery4: require('./assets/Experimind_Gallery_4.webp'),
    gallery5: require('./assets/Experimind_Gallery_5.webp'),
    gallery6: require('./assets/Experimind_Gallery_6.webp'),
    gallery7: require('./assets/Experimind_Gallery_7.webp'),
    gallery8: require('./assets/Experimind_Gallery_8.webp'),
    gallery9: require('./assets/Experimind_Gallery_9.webp'),
    gallery10: require('./assets/Experimind_Gallery_10.webp'),
}
export default image;